export default "__VITE_ASSET__CbwRdycO__"